import { RequestParameters, Variables } from 'relay-runtime';

export const getAtlAttributionHeader = (request: RequestParameters, variables: Variables): {
    'atl-attribution': string;
} => {
	const workspaceId = variables['containerId']
		? variables['containerId']
		: variables['cloudId']
			? variables['cloudId']
			: '';
	return {
		'atl-attribution': JSON.stringify({
			atlWorkspaceId: workspaceId,
			tenantId: workspaceId, // tenantId (ARI) for the tenant in respective org
			product: 'Atlassian Home', //The product to which the upstream service belongs
			service: 'townsquare-frontend', //Name of the upstream service
		}),
	};
};
